import _ from 'lodash/'
import { StepNlpSettings } from '@feedyou/schema'
import produce from 'immer'

export function getValidationErrors(formData: StepNlpSettings) {
  return produce({}, draft => {
    if (!formData?.configurations) {
      return
    }

    const idCounts = _.countBy(formData.configurations, 'id')
    formData.configurations.forEach((config, index) => {
      if (idCounts[config.id] > 1) {
        // @ts-ignore
        draft[`configurations.${index}.id`] = 'This id is used by another configuration'
      }
    })
  })
}
